import createAction from '../../redux/createAction';
import localeActionstypes from './localizationActionstypes';

export const storeLocale = createAction(
  localeActionstypes.SET_LOCALE
);
